export default __webpack_public_path__ + "0c36d6c273b2f5540753484feac4efee.woff2";